<ihd-modal
    class="x-dialog-order-refund__modal c-modal--sm"
    [createOverlay]="false"
>
    <div class="c-modal__header">
        <ihd-media
            class="c-media--modal-header c-media__icon--circle c-media__icon--order"
            media="chat"
            [heading]="'Order.Note.Title' | translate"
        >
        </ihd-media>
        <ihd-button-group class="ml-auto c-btn-group--gap-3">
            <button
                ihdIconButton
                icon="close"
                class="x-modal__icon-btn c-icon-btn--xs"
                (click)="close()"
            >
                <ihd-tooltip>{{ 'Common.Close' | translate }}</ihd-tooltip>
            </button>
        </ihd-button-group>
    </div>

    <div class="c-modal__body" [formGroup]="editForm">
        <div class="c-modal__body-content">
            <div class="c-form-group">
                <label>{{ 'Order.Note.Note' | translate }}</label>
                <textarea
                    class="c-form-control"
                    [placeholder]="'Order.Note.Placeholder' | translate"
                    ihdAutoFocus
                    formControlName="managerNote"
                    rows="5"
                ></textarea>
            </div>
            <div class="c-modal__actions d-flex align-items-center">
                <div>
                    {{ 'Order.Note.OnlyManagers' | translate }}
                </div>
                <button
                    ihdButton
                    class="c-btn--primary c-btn--wmd c-btn--lg ml-auto"
                    (click)="sendRequest()"
                    [disabled]="busy"
                >
                    {{ 'Common.Save' | translate }}
                </button>
            </div>
        </div>
    </div>
</ihd-modal>
